<template>
  <div class="home">
    <div class="headers">
      <div class="back">
        <span class="tips" @click="gotopage('home')">首页</span>
      </div>
      <!-- <el-tree
        class="menu"
        :data="menuData"
        :props="defaultProps1"
        @node-click="handleNodeClick"
        node-key="id"
      ></el-tree> -->
      <div class="datetime">
        <el-select
          v-model="organization"
          placeholder=""
          @change="handleNodeClick"
        >
          <el-option
            v-for="item in menuData"
            :key="item.id"
            :label="item.branchName"
            :value="item.index"
          >
          </el-option>
        </el-select>
      </div>
      <div class="orgSelect">
        <el-select
          v-model="orgSelectModel"
          placeholder=""
          @change="handleOrgNodeClick"
        >
          <el-option
            v-for="item in orgData"
            :key="item.branchId"
            :label="item.branchName"
            :value="item.branchId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="logo">
        常青社运营大数据- {{ title }}
      </div>
    </div>
    <div class="main">
      <div class="mainTop">
        <div class="maTopInfo">
          <!-- <div class="inItem">
            <img src="../assets/area/sztb.png" alt="" class="smtopImg" />
            <div class="infoValue siteTiips">
              <p>区域机构数(家)</p>
              <p class="topNum">{{ orgInfo.branchCount }}</p>
            </div>
          </div> -->
          <div class="inItem">
            <img src="../assets/area/sztb.png" alt="" class="smtopImg" />
            <div class="infoValue">
              <p class="topTit">区域床位数(床)</p>
              <p class="topNum3">{{ orgInfo.beds }}</p>
            </div>
          </div>
          <div class="inItem">
            <img src="../assets/area/sztb.png" alt="" class="smtopImg" />
            <div class="infoValue">
              <p class="topTit">在住长者</p>
              <p class="topNum3">{{ orgInfo.intoElders }}</p>
            </div>
          </div>
          <div class="inItem">
            <img src="../assets/area/sztb.png" alt="" class="smtopImg" />
            <div class="infoValue">
              <p class="topTit">入住率</p>
              <p class="topNum3">{{ orgInfo.occupancyRate }} %</p>
            </div>
          </div>
        </div>
      </div>
      <div class="institutionInfo">
        <div class="city">{{ orgInfo.branchName }}</div>
        <div class="listBox" v-if="institution.length > 0">
          <div
            class="listItem"
            v-for="(item, index) in institution"
            :key="index"
          >
            <template v-if="item.name == 3">
              <img src="../assets/site/jigou.png" alt="" />
              <span style="margin-left: 30px">养老机构：</span>
            </template>
            <template v-if="item.name == 2">
              <img src="../assets/site/zhandian.png" alt="" />
              <span style="margin-left: 30px">中心站点：</span>
            </template>
            <template v-if="item.name == 1">
              <img src="../assets/site/yiyuan.png" alt="" />
              <span style="margin-left: 30px">社区站点：</span>
            </template>
            <span>{{ item.num }}</span>
          </div>
        </div>
      </div>
      <div class="mainBottom">
        <div class="mainBoLeft">
          <div id="mapContainer"></div>
        </div>
        <div class="mainBoRight">
          <div class="rimgItem">
            <swiper
              :options="swiperOption"
              @slideChangeTransitionEnd="onSlideChange"
            >
              <swiper-slide v-for="item in imgList" :key="item.id">
                <img
                  style="width: 100%; height: 100%"
                  :src="`/ophApi/commonAttachDown/download?id=${item.id}`"
                  alt=""
                />
                <div class="siteTipsName">{{item.title}}</div>
              </swiper-slide>

              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            </swiper>
            <img  style="position: absolute" src="../assets/area/xiaokuang.png" alt="" class="bgimg" />
          </div>
          <!-- <div class="rimgItem">
            <swiper
              :options="swiperOption"
              @slideChangeTransitionEnd="onSlideChange"
            >
              <swiper-slide v-for="item in imgList2" :key="item.id">
                <img
                  :src="`/ophApi/commonAttachDown/download?id=${item.id}`"
                  alt=""
                />
                <div class="siteTipsName">{{item.title}}</div>
              </swiper-slide>

            </swiper>
            <img style="position: absolute" src="../assets/area/xiaokuang.png" alt="" class="bgimg" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Hls from 'hls.js'
import moment from 'moment'
import Highcharts from 'highcharts'
import mapStyleJson from './custom_map_config.json'

export default {
  name: '',
  data () {
    return {
      city: '',
      orgInfo: {},
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 9000
        }
      },
      imgList: [],
      imgList2: [],
      institution: [],
      menuData: [],
      orgData: [],
      orgSelectModel: '',
      title: '',
      data: [
        {
          id: 0,
          label: '一级 1',
          children: [
            {
              id: 0,
              label: '二级 1-1'
            }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      defaultProps1: {
        children: 'children',
        label: 'branchName'
      },
      homeInfos: null,
      organization: ''
      // branchName
    }
  },
  created () {
    this.city = this.$route.query.city
    this.getinfo(this.city)
    this.getmenu(this.city)
    this.organization = this.city
    console.log(this.menuData)
  },
  mounted () {
    var that = this
    this.$nextTick(async () => {
      that.mspinfo()
    })
  },
  methods: {
    mspinfo () {
      var that = this
      const data = this.orgInfo.children
      var map = new BMapGL.Map('mapContainer')
      map.centerAndZoom(
        new BMapGL.Point(data[0].longitude, data[0].latitude),
        9
      )
      map.setMapStyleV2({ styleJson: mapStyleJson })
      map.enableScrollWheelZoom(true)
      data.forEach((e, i) => {
        var pt = new BMapGL.Point(e.longitude, e.latitude)
        if (e.orgPropertyType == 1) {
          var icons = require('../assets/site/yiyuan.png')
          var myIcon = new BMapGL.Icon(
            icons,
            new BMapGL.Size(32, 38), // 视窗大小
            {
              imageSize: new BMapGL.Size(32, 38), // 显示图标大小(根据实际大小等比例缩放)
              imageOffset: new BMapGL.Size(0, 0) // 图片相对视窗的偏移
            }
          )
        } else if (e.orgPropertyType == 2) {
          var icons = require('../assets/site/zhandian.png')
          var myIcon = new BMapGL.Icon(
            icons,
            new BMapGL.Size(36, 56), // 视窗大小
            {
              imageSize: new BMapGL.Size(36, 65), // 显示图标大小(根据实际大小等比例缩放)
              imageOffset: new BMapGL.Size(0, 0) // 图片相对视窗的偏移
            }
          )
        } else if (e.orgPropertyType == 3) {
          var icons = require('../assets/site/jigou.png')
          var myIcon = new BMapGL.Icon(
            icons,
            new BMapGL.Size(34, 38), // 视窗大小
            {
              imageSize: new BMapGL.Size(34, 38), // 显示图标大小(根据实际大小等比例缩放)
              imageOffset: new BMapGL.Size(0, 0) // 图片相对视窗的偏移
            }
          )
        }
        var content = e.branchName
        var label = new BMapGL.Label(content, {
          // 创建文本标注
          position: pt,
          offset: new BMapGL.Size(10, 20)
        })
        label.setStyle({
          // 设置label的样式
          color: '#fff',
          fontSize: '16px',
          border: '2px solid #1E90FF',
          backgroundColor: '#0066ff'
        })
        var maker = new BMapGL.Marker(pt, { icon: myIcon }) // 创建标注
        // 点标记添加点击事件
        if (e.orgPropertyType == 1) {
          maker.addEventListener('click', function () {
            console.log('社区站点')
          })
        } else if (e.orgPropertyType == 2) {
          maker.addEventListener('click', function () {
            console.log('中心站点')
            that.$router.push({
              name: 'org',
              query: { id: i, city: that.city }
            })
          })
        } else if (e.orgPropertyType == 3) {
          maker.addEventListener('click', function () {
            console.log('养老机构')
            // this.$router.push('org')
            that.$router.push({
              name: 'org',
              query: { id: i, city: that.city }
            })
          })
        }

        map.addOverlay(maker)
        map.addOverlay(label)
      })
    },
    handleNodeClick (val) {
      this.menuData.forEach((item, i) => {
        if (val === item.index) {
          const index = item.index
          this.city = index
          this.getmenu(index)
          this.getinfo(index)
          this.mspinfo()
        }
      })
    },
    getinfo (index) {
      this.homeInfos = JSON.parse(localStorage.homeInfos)
      this.orgInfo = this.homeInfos[index]
      console.log(this.homeInfos, 'getinfo')
      // var imgArray = this.arrayChunk(this.orgInfo.honorWallList, 2);
      this.imgList = this.orgInfo.honorWallList
      // this.imgList = imgArray[0];
      // this.imgList2 = imgArray[1];

      this.institution = this.repetition(this.orgInfo.children)
      // 中心站点,机构
      this.orgData = []
      this.orgInfo.children.forEach((item, i) => {
        if (item.orgPropertyType === 2 || item.orgPropertyType === 3) {
          const object = {
            branchId: item.branchId,
            branchName: item.branchName,
            index: i
          }
          this.orgData.push(object)
        }
      })
      console.log(this.orgData, 'orgData')
    },
    handleOrgNodeClick (val) {
      const that = this
      this.orgData.forEach((item, i) => {
        if (item.branchId === val) {
          that.$router.push({
            name: 'org',
            query: { id: item.index, city: that.city }
          })
        }
      })
    },
    getmenu (num) {
      this.$http.get('/biDataDaily/navMenuInfo').then((res) => {
        const data = []
        const array = res.data.data.children
        array.forEach((element, i) => {
          const object = {
            id: element.id,
            branchName: element.branchName,
            children: [],
            index: i
          }
          data.push(object)
        })
        console.log(data, 'data')
        this.menuData = data
        console.log(res.data.data.children, 'res.children')
        const index = num * 1
        this.title = data[index].branchName
      })
    },
    gotopage () {
      history.back()
    },
    onSlideChange ($swiper) {
      // console.log($swiper.activeIndex);
    },
    // arrayChunk(array, size) {
    //   let data = [];
    //   for (let i = 0; i < array.length; i += size) {
    //     data.push(array.slice(i, i + size));
    //   }
    //   return data;
    // },
    repetition (arr) {
      if (arr) {
        var newArr = [...new Set(arr.map((i) => i.orgPropertyType))] // 去重的时候需要注意和普通数组不同
        var list = []
        console.log(newArr, 'newArr')
        newArr.forEach((i) => {
          list.push(arr.filter((t) => t.orgPropertyType === i))
        })
        console.log(list, 'list')
        var mlist = []
        list.forEach((i, index) => {
          mlist.push({
            name: newArr[index],
            num: i.length
          })
        })
        console.log(mlist, 'mlist')
        return mlist
      } else {
        return []
      }
    }
  },
  computed: {},
  beforeDestroy () {}
}
</script>
<style lang="scss" scoped>
.home {
  width: 1920px;
  height: 1080px;
  background: url("../assets/home/bg.jpg");
}
.headers {
  width: 100%;
  height: 116px;
  background: url("../assets/home/logokuang.png") no-repeat;
  background-position: center bottom;
  position: relative;
  display: flex;
  align-items: center;
}
.back{
  z-index: 2;
  /* margin-right: 15px; */
  /* margin-left: 20px; */
  /* width: 100px; */
  /* position: absolute;
  top: 23px;
  left: 20px; */
}
.tips{
  font-size: 30px;
  cursor: pointer;
  color: aqua;
  margin-left: 20px;
  /* font-family: "pangmenzhengdao"; */
}
.logo {
  width: 100%;
  line-height: 116px;
  font-size: 34px;
  color: #08fbfb;
  font-family: "pangmenzhengdao";
  position: absolute;
  top: 0;
  left: 0;
  /* background: url('../assets/site/declogo.png') no-repeat;
      background-position: center top 20px; */
}
.datetime {
  z-index: 2;
  width: 255px;
  /* position: absolute;
  top: 26px;
  left: 120px; */
  /* padding-right: 24px; */
  margin-left: 15px;
  box-sizing: border-box;
  font-size: 28px;
}
.datetime span {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}
.goBack {
  position: absolute;
  width: 55px;
  height: 42px;
  left: 50px;
  top: 20px;
  cursor: pointer;
}
.main {
  padding: 0 !important;
  display: block !important;
  height: calc(100% - 116px);
}
.mainTop {
  width: 100%;
  height: 180px;
  background: url("../assets/area/bjzs.png") no-repeat;
  /* position: relative; */
  z-index: 1;
}
.maTopInfo {
  width: 100%;
  height: 85%;
  z-index: 2;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.inItem {
  width: 33%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.smtopImg {
  width: 93px;
  height: 108px;
  /* position: absolute; */
  /* display: inline-block; */
  left: 75px;
  top: 5px;
}
.infoValue {
  /* display: inline-block; */
  margin-left: 50px;
}
.siteTiips{
  font-size: 18px;
}
.topTit{
  font-size: 24px;
}
.topNum3 {
  text-align: left;
  color: #f7f489;
  font-weight: bolder;
  font-size: 24px;
  padding: 0;
  margin: 0;
}
.mainBottom {
  width: 90%;
  height: 680px;
  margin: 0 auto;
  display: flex;
  margin-top: 20px;
}
.mainBoLeft {
  flex: 6;
  height: 100%;
  position: relative;
  background: url("../assets/area/dakuang.png") no-repeat;
  background-size: 100% 99%;
}
#mapContainer {
  position: absolute;
  width: 95%;
  height: 90%;
  left: 25px;
  top: 18px;
}
.institutionInfo {
  width: 160px;
  margin-left: 110px;
  cursor: pointer;
}

.institutionInfo:hover .listBox {
  display: block;
}
.bgimg {
  /* position: absolute; */
  width: 97%;
  height: 98%;
  right: 0;
  top: 0;
  z-index: 1;
}
.mainBoRight {
  flex: 3;
  overflow: hidden;
}
.rimgItem {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper-container {
  position: relative;
  width: 90%;
  height: 87%;
  top: 4% !important;
  left: 1% !important;
}
.swiper-slide {
  /* background-color: #fff;
  color: #f7f489; */
}
.city {
  width: 150px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 5px solid #ffc34b;
  top: 20px;
  /* position: absolute; */
  z-index: 1;
  left: 42px;
  border-radius: 12px;
  font-size: 18px;
}

.listBox {
  display: none;
  width: 150px;
  position: absolute;
  z-index: 1;
  top: 345px;
  left: 110px;
  border-radius: 12px;
  font-size: 14px;
  border: 5px solid #ffc34b;
  background-color: #2c3e50;
}
.listItem {
  margin: 10px 0;
}
.listItem span {
  margin-left: 10px;
}

.listItem img {
  width: 35px;
  height: 30px;
  position: absolute;
  left: 5px;
}
.menu {
  position: absolute;
  left: 115px;
  background-color: #06156100;
  width: 300px;
}

.el-tree-node__content:hover {
  background-color: #06156100 !important;
}
.el-tree-node:focus > .el-tree-node__content {
  background-color: #06156100 !important;
}
.siteTipsName {
  position: absolute;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  font-size: 15px;
  bottom: 0px;
}
.orgSelect {
  z-index: 2;
  position: relative;
  margin-left: 15px;
  with: 255px;
}
::v-deep .el-select .el-input .el-select__caret {
  color: #c0c4cc00;
}
::v-deep .el-input__inner {
  background-color: #fff0;
  color: #08fbfb;
  border: 1px solid #08fbfb;
  font-size: 24px;
}
</style>
